import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const INFINITE_SURVEYS_QUERY_KEY = 'survey/eventRegistration';

export function useInfiniteEventRegistrationSurveys({
	shouldIncludeArchived = false,
	shouldIncludeExpired = false,
	search = '',
	pageSize = 100,
	enabled = true,
	impersonationContext,
}: {
	shouldIncludeArchived?: boolean;
	shouldIncludeExpired?: boolean;
	search?: string;
	pageSize?: number;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Api.IEventRegistrationSurvey>>({
		enabled,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: async ({ pageParam }) => {
			const page = await userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IEventRegistrationSurvey>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: {
						includeArchived: shouldIncludeArchived,
						includeExpired: shouldIncludeExpired,
						search,
						pageToken: pageParam,
					},
					urlPath: `survey/eventRegistration`,
				}),
				'GET',
				null
			);

			return page;
		},
		queryKey: [
			INFINITE_SURVEYS_QUERY_KEY,
			shouldIncludeArchived,
			shouldIncludeExpired,
			search,
			pageSize,
			enabled,
			impersonationContext,
		],
		initialPageParam: '',
	});
}

export const invalidateInfiniteEventRegistrationSurveys = () => {
	reactQueryClient.invalidateQueries({ queryKey: [INFINITE_SURVEYS_QUERY_KEY] });
};
